import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DeletedHeartRunnerComponent from '../components/deletedHeartRunnerComponent';
import {getDeletedUserList, deleteUser, ReApproveUser,getAllRegionSettings} from '../actions/deletedHeartRunnerAction';

class DeletedHeartRunnerContainer extends Component {
    constructor(props){
        super(props)
    }
    componentDidMount(){
       // this.props.actions.getDeletedUserList();
         this.props.actions.getAllRegionSettings();
    }
    getUserList = (data) =>{
                    this.props.actions.getDeletedUserList(data,
                        this.props.dispatch
                    )
                }
    onDelete = (requestPayload,Region) => {
        this.props.actions.deleteUser(
            requestPayload,Region,
            this.props.dispatch
        )
    }
    getList = () => {
        this.props.actions.getDeletedUserList(
            this.props.dispatch
        )
    }
    ReApprove = (requestPayload,Region) =>{
        this.props.actions.ReApproveUser(
            requestPayload,Region,
            this.props.dispatch
        )
    }
    getRegionData = () => {
                     this.props.actions.getAllRegionSettings(this.props.dispatch);
                  } 
    render() {
        return(
            <div className="agile-grids">
                            <div className="grids">
                                <div className="container">
                                    <div className="row">
                                       <DeletedHeartRunnerComponent
                    deletedHeartRunnerData = {this.props.deletedHeartRunnerData}
                    onDelete = {this.onDelete}
                    getList = {this.getList}
                    ReApprove = {this.ReApprove}
                       getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
               >
               </DeletedHeartRunnerComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
            
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getDeletedUserList,
            deleteUser,
            ReApproveUser,
             getAllRegionSettings
        }, dispatch)
    };
};

function mapStateToProps({deletedHeartRunnerReducer}) {
    console.log(deletedHeartRunnerReducer)
    return {
        deletedHeartRunnerData: {
            errorCode : deletedHeartRunnerReducer.errorCode,
            statusCode : deletedHeartRunnerReducer.statusCode,
            message : deletedHeartRunnerReducer.message,
            deletedHeartRunnerList : deletedHeartRunnerReducer.deletedHeartRunnerList,
            regionList : deletedHeartRunnerReducer.regionList,
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeletedHeartRunnerContainer))